var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-navbar',{attrs:{"id":"navbarauth-v3"}},[_c('b-navbar-brand',{attrs:{"href":"https://jaybod.com"}},[_c('div',{staticClass:"margin-left-logo-v3"},[_c('img',{staticClass:"cursor-pointer px-2 img-fluid logo-jaybod-v3",attrs:{"crossorigin":"anonymous","src":this.$logo,"alt":""}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }